import moment from 'moment';

const formatDate = (dateTime: moment.MomentInput) => {
  if (!dateTime) {
    return '';
  }
  return moment(dateTime).format('DD MMM. YYYY');
};

export default formatDate;

export const formatAPIDate = (dateTime: moment.MomentInput) => {
  if (dateTime === '') {
    return '';
  }
  return moment(dateTime).format('YYYY-MM-DD');
};

export const ANT_PICKERS_FORMAT = 'DD.MM.YYYY';
